import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';

const Strip = styled.div`
  position: relative;
  z-index: 1;
  overflow: hidden;
  background: ${theme.accent};
  padding: 14px 0;
  border-top: 2px solid ${theme.border};
  border-bottom: 2px solid ${theme.border};
`;
const Track = styled.div`
  display: flex;
  width: max-content;
  animation: marquee 22s linear infinite;
`;
const Row = styled.div`
  display: flex;
  gap: 36px;
  padding-right: 36px;
  font-family: ${theme.fontHeading};
  font-weight: 800;
  font-size: 17px;
  text-transform: uppercase;
  color: ${theme.bg};
  white-space: nowrap;
`;

const items = ['React', 'Node.js', 'MySQL', 'Redis', 'Docker', 'WebSockets', 'Linux', 'Available for work'];

function RowContent() {
  return (
    <>
      {items.map((item) => (
        <React.Fragment key={item}>
          <span>{item}</span>
          <span>&#9670;</span>
        </React.Fragment>
      ))}
    </>
  );
}

export default function Ticker() {
  return (
    <Strip>
      <Track>
        <Row><RowContent /></Row>
        <Row aria-hidden="true"><RowContent /></Row>
      </Track>
    </Strip>
  );
}
